import MainBar from './MainBar';
import Header from './Header';
import ActionBar from './ActionBar';
import QuickNavigation from './QuickNavigation';
import AuthLayout from './AuthLayout';
import MainLayout from './MainLayout';
import LayoutNavigation from './Navigation';
import NotFound from './NotFound';
import PageContent from './PageContent';
import Sidebar from './Sidebar';
import Wrapper from './Wrapper';

export {
  MainBar as MainBarLayout,
  Header,
  ActionBar,
  QuickNavigation,
  AuthLayout,
  MainLayout,
  LayoutNavigation,
  NotFound,
  PageContent,
  Sidebar,
  Wrapper
};



// WEBPACK FOOTER //
// ./src/modules/layout/components/index.js